import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';

import { Response, Section, SectionsResponse } from '@lemonsolutions/models';
import { ModalService } from '@ls-commons/utils/modals';

@Injectable({
  providedIn: 'root',
})
export class SectionService {
  readonly http = inject(HttpClient);
  readonly modalService = inject(ModalService);

  getSections(type: number, lang: string): Observable<Section[]> {
    let params = new HttpParams().set('lang', lang);
    params = params.set('all', true);
    return this.http.get<SectionsResponse>(`section/${type}`, { params }).pipe(
      map(resp => resp.data),
      catchError(err => this.handleError(err, 'Recuperar secciones'))
    );
  }

  getSection(type: number, id: number): Observable<Section[]> {
    return this.http.get<SectionsResponse>(`section/${type}/item/${id}`).pipe(
      map(resp => resp.data),
      catchError(err => this.handleError(err, 'Recuperar sección'))
    );
  }

  deleteSection(type: number, id: number): Observable<boolean> {
    return this.http
      .delete<boolean>(`section/${type}/item/${id}`)
      .pipe(catchError(err => this.handleError(err, 'Eliminar sección')));
  }

  activeSection(type: number, id: number): Observable<boolean> {
    return this.http
      .post<boolean>(`section/${type}/item/${id}/active`, null)
      .pipe(catchError(err => this.handleError(err, 'Activar sección')));
  }

  saveSection(
    type: number,
    id: number,
    section: Section[],
    images: { file: File }[]
  ): Observable<Response> {
    const formData: FormData = new FormData();
    for (const image of images) {
      image?.file && formData.append('image', image.file, image.file.name);
    }

    formData.append('section', JSON.stringify(section));
    return this.http
      .put<Response>(`section/${type}/item/${id}`, formData)
      .pipe(catchError(err => this.handleError(err, 'Save Section')));
  }

  addSection(
    type: number,
    section: Section[],
    images: { file: File }[]
  ): Observable<Response> {
    const formData: FormData = new FormData();
    for (const image of images) {
      image?.file && formData.append('image', image.file, image.file.name);
    }

    formData.append('section', JSON.stringify(section));
    return this.http
      .post<Response>(`section/${type}/item/add`, formData)
      .pipe(catchError(err => this.handleError(err, 'Save Section')));
  }

  reorder(type: number, sections: Partial<Section>[]): Observable<Response> {
    return this.http
      .post<Response>(`section/${type}/reorder`, sections)
      .pipe(catchError(err => this.handleError(err, 'Reorder')));
  }

  private handleError(err: any, error: string) {
    const msg =
      err.status === 400 ? err.error.msg : `Se ha producido un error: ${error}`;
    this.modalService.showErrorMessage(msg);
    return throwError(() => msg);
  }
}
